import React from "react"
import { Link, graphql } from "gatsby"
import { rhythm } from "../utils/typography"

import listStyle from '../style/list-style.module.scss';
import mainStyle from '../style/main.module.scss';

import { getAllCategories } from '../utils/get-all-category'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Category from '../components/category/category';

import catBgImage from "../../content/assets/cat-bg.svg";
import dogBgImage from "../../content/assets/dog-bg.svg";

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges
  const availableCategories = getAllCategories(posts);

  return (
    <Layout availableCategories={availableCategories} location={location} title={siteTitle}>
      <SEO
        lang="uk"
        title="Щоденник чотирилапого - Все про собак та котів"
        description="Корисні та цікаві статті про собак та котів. Все що потрібно знати при утриманні чотирилапих друзів"
      />
      <div style={{ backgroundImage: `url(${catBgImage}), url(${dogBgImage})` }} className={mainStyle.container}>
        {/* <div className={mainStyle.overlay}></div> */}
        <div className={mainStyle.inner}>
          <h1 className={mainStyle.title}>
            {/* Pets Love <br /> */}
          Щоденник чотирилапого
        </h1>
          <p className={mainStyle.subtitle}>Все про собак та котів</p>
          <p className={mainStyle.text}>
            <span className={mainStyle.no_wrap}>● Породи</span>
            <span className={mainStyle.no_wrap}>● Здоров'я</span>
            <span className={mainStyle.no_wrap}>● Харчування</span>
            <span className={mainStyle.no_wrap}>● Звички</span>
          </p>
        </div>
      </div>
      <div className={listStyle.container}>
        {posts.map(({ node }) => {
          const data = node.frontmatter;
          return (
            <article className={listStyle.article} key={node.fields.slug}>
              <div
                style={{
                  backgroundImage: `url(${data.image.childImageSharp.fluid.src})`
                }}
                className={listStyle.article__photo}>
                <div className={listStyle.article__photo_overlay}></div>
              </div>
              <div className={listStyle.article__categories}>
                <Category categories={data.categories} />
              </div>
              <Link className={listStyle.article__title} to={node.fields.slug}>
                {data.title}
              </Link>
              <section>
                <p>{data.teaser}</p>
              </section>
              <div className={listStyle.article__actions}>
                <Link className={listStyle.article__actions_button} to={node.fields.slug}>
                  Читати
                </Link>
              </div>
            </article>
          )
        })}
      </div>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            teaser
            categories {
              name
              isDog
              isCat
              value
              priority
              description
            }
            image {
              childImageSharp {
                fluid {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`


/*
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <article key={node.fields.slug}>
              <header>
                <h3
                  style={{
                    marginBottom: rhythm(1 / 4),
                  }}
                >
                  <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                    {title}
                  </Link>
                </h3>
                <small>{node.frontmatter.date}</small>
              </header>
              <section>
                <p
                  dangerouslySetInnerHTML={{
                    __html: node.frontmatter.description || node.excerpt,
                  }}
                />
              </section>
            </article>
          )
        })}
*/